import { CanvasUtils, Dimension } from "./canvasUtils";
import { ContainedDragEvent, ContainedDragListener } from "./containedDragListener";
import { DDSB } from "./ddsb";
import { Z } from "./query";
import { AcceptablePanelSizes } from "./quoteBuilder";

let app: DDSB;
const Darkroom = window['Darkroom'];

const DataTransferImageWidth = 640;

/*
    TODO: 2024-05-15
    // 1) Refactor image selection/camera tool - move to a popup modal to allow for
    //      1.1: scale and crop image adjustment
    //      1.2: select image scale - implement image/scale definition metadata and guess at scale for current stock images.
    // 2) Adjust sign designer tool to work better on mobile devices. Clear out available real estate and
    //      select more intuitive default grid scale (allow at minimum selecting a 10x10 metre square sign)
*/

export type SignDesignerTool = 'background' | 'select' | 'scale';

export class SignDesigner {
    static instance: SignDesigner;

    container: HTMLElement;
    canvasContainer: HTMLElement;
    canvas: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    toolbar: HTMLElement;

    //selectionX: number = 0;
    //selectionY: number = 0;
    selectionWidth: number = (parseInt(Z.valueOf('#RequestedSignWidthInMM', 960)) / 320) || 3;
    selectionHeight: number = (parseInt(Z.valueOf('#RequestedSignHeightInMM', 960)) / 320) || 3;

    /*
    get selectionX() {
        return parseInt(Z.valueOf('#GridSelectionX', '0'));
    }
    set selectionX(to: number) {
        if (this.selectionX != to) this.onDiff();
        Z.setValue('#GridSelectionX', to, false);
    }
    get selectionY() {
        return parseInt(Z.valueOf('#GridSelectionY', '0'));
    }
    set selectionY(to: number) {
        if (this.selectionY != to) this.onDiff();
        Z.setValue('#GridSelectionY', to, false);
    }
    */

    //backgroundX: number = 0;
    //backgroundY: number = 0;
    //backgroundScale: number = 1;

    diffTimeout = null;
    onDiff() {
        clearTimeout(this.diffTimeout);
        this.diffTimeout = setTimeout(() => {
            app.quoteBuilder.updateForm(false);
        }, 1000);
    }

    get backgroundX() { return parseFloat(Z.valueOf('#BackgroundX', '0')); }
    set backgroundX(to: number) {
        if (this.backgroundX != to) this.onDiff();
        Z.setValue('#BackgroundX', to, false);
    }
    get backgroundY() { return parseFloat(Z.valueOf('#BackgroundY', '0')); }
    set backgroundY(to: number) {
        if (this.backgroundY != to) this.onDiff();
        Z.setValue('#BackgroundY', to, false);
    }
    get backgroundScale() { return parseFloat(Z.valueOf('#BackgroundScale', '1')); }
    set backgroundScale(to: number) {
        if (this.backgroundScale != to) this.onDiff();

        if (to == 0) to = 1;
        Z.setValue('#BackgroundScale', to, false);
    }

    activeBackground: HTMLImageElement = null;

    get backgroundWidth() { return this.activeBackground ? this.activeBackground.naturalWidth : 0; }
    get backgroundHeight() { return this.activeBackground ? this.activeBackground.naturalHeight : 0; }

    ddsbBrandNavyRgba(opacity: number = 1) {
        return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-navy-rgb')}, ${opacity})`;
    }
    ddsbBrandCyanRgba(opacity: number = 1) {
        return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-cyan-rgb')}, ${opacity})`;
    }
    ddsbBrandBlueRgba(opacity: number = 1) {
        return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-blue-rgb')}, ${opacity})`;
    }
    ddsbBrandMagentaRgba(opacity: number = 1) {
        return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-magenta-rgb')}, ${opacity})`;
    }

    get gridToolBackgroundColour() { return 'white'; }
    //get gridToolGridLineColour() { return this.ddsbBrandBlueRgba(0.25); }
    get gridToolGridLineColour() { return `rgba(0, 0, 0, 0.3)`; }
    get gridToolLegendColour() { return this.ddsbBrandNavyRgba(1); }
    get gridToolLabelColour() { return this.ddsbBrandNavyRgba(1); }
    get gridToolLabelShadowColour() { return this.ddsbBrandCyanRgba(0); }
    get gridToolSelectionBackgroundColour() { return this.ddsbBrandCyanRgba(0.75); }
    get gridToolSelectionBorderColour() { return this.ddsbBrandNavyRgba(1); }
    get gridToolHoverBorderColour() { return this.ddsbBrandNavyRgba(0.5); }

    get activeTool() {
        return 'select';
    }

    /*get activeTool(): SignDesignerTool { return <SignDesignerTool>Z.first('[data-quote-gui-tool].active').dataset.quoteGuiTool; }
    set activeTool(to: SignDesignerTool) {
        Z.forFirst(`[data-quote-gui-tool="${to}"]`, el => el.click());
    } */

    get ppi() { return (96 * window.devicePixelRatio) / 100; }
    get dpi() { return Math.round(96 * this.ppi); }
    get dpcm() { return this.dpi / 2.54; }
    get dpmm() { return this.dpcm * 10; }
    get dpm() { return this.dpcm / 100; }
    /*
    get gridOffsetX() { return 0; }
    get gridOffsetY() { return 0; }
    */

    //get gridStep() { return Math.floor(this.dpcm * this.gridScale); }
    /*set gridStep(to: number) {
        if (to == 0) return;
        this.gridScale = to / this.dpcm;
    }*/
    get gridStep() {
        let nominal = (((this.canvas?.width ?? 1) * (this.gridFixedMetreScale)) / 1000) * 320;
        if (isNaN(nominal) || nominal < 1) return 50;
        return nominal;
    }
    //set gridStep(to: number) { }

    /*
    get metreScale() { return (this.gridStep / 320) * 1000; }
    set metreScale(to: number) {
        //if (to < 50) return;
        if (to < 10) return;
        this.gridStep = (to / 1000) * 320;
    }
    get gridCellsWide() { return Math.floor((this.canvas.width - this.gridOffsetX * 2) / this.gridStep); }
    get gridCellsTall() { return Math.floor((this.canvas.height - this.gridOffsetY * 2) / this.gridStep); }
    get gridWidth() { return this.gridCellsWide * this.gridStep; }
    get gridHeight() { return this.gridCellsTall * this.gridStep; }
    */

    //gridFixedMetreScale: number = 0.001;
    get gridFixedMetreScale() {
        let nominal = parseFloat(Z.valueOf('#FixedGridMetreScale', '0.001'));
        if (isNaN(nominal) || nominal <= 0) nominal = 0.001;
        return nominal;
    }
    set gridFixedMetreScale(to: number) {
        if (to <= 0 || isNaN(to)) to = 0.001;
        Z.setValue('#FixedGridMetreScale', to.toString(), true);
    }

    gridFixedToImage: boolean = true;

    repaint2() {
        let ctx = this.context;
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        ctx.fillStyle = this.gridToolBackgroundColour;
        ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        //this.gridStep = this.gridFixedMetreScale * 0.32;
        //let fgStep = this.gridFixedMetreScale * this.canvas.width;

        if (this.activeBackground) {
            try {

                let bounds = CanvasUtils.bestFit({
                    width: this.activeBackground.naturalWidth,
                    height: this.activeBackground.naturalHeight,
                }, {
                    width: this.canvas.width,
                    height: this.canvas.height,
                });

                bounds.x = 0;
                bounds.y = 0;
                this.backgroundWidthOfCanvas = bounds.width / this.canvas.width;
                this.backgroundHeightOfCanvas = bounds.height / this.canvas.height;

                ctx.drawImage(this.activeBackground, bounds.x, bounds.y, bounds.width, bounds.height);
            } catch (err) {
            }

            /* let gridStep = this.canvas.width * (this.gridFixedMetreScale * 0.32);
            for (let y = 0, i = 0; y < this.canvas.height; y += gridStep, i++) {
                ctx.strokeStyle = (i % 3) ? `white` : `black`;
                ctx.beginPath();
                ctx.moveTo(0, y);
                ctx.lineTo(this.canvas.width, y);
                ctx.stroke();
            }
            for (let x = 0, i = 0; x < this.canvas.width; x += gridStep, i++) {
                ctx.strokeStyle = (i % 3) ? `white` : `black`;
                ctx.beginPath();
                ctx.moveTo(x, 0);
                ctx.lineTo(x, this.canvas.height);
                ctx.stroke();
            } */
        } else {
            this.backgroundWidthOfCanvas = 0.5;
            this.backgroundHeightOfCanvas = 0.5;

            let defBg1 = Z.one<HTMLImageElement>('img#default-sign-bg-image-1');
            let defBg2 = Z.one<HTMLImageElement>('img#default-sign-bg-image-2');

            let bgBounds = CanvasUtils.bestFit({ width: defBg2.naturalWidth, height: defBg2.naturalHeight }, this.canvas);
            ctx.drawImage(defBg1, 0, 0, this.canvas.width, this.canvas.height);
            ctx.drawImage(defBg2, bgBounds.x, bgBounds.y, bgBounds.width, bgBounds.height);
        }
        let fgStep = this.gridStep * this.backgroundWidthOfCanvas;

        if (this.fixedGridSelectX >= 0 && this.fixedGridSelectHeight >= 0) {
            let fgx = this.fixedGridSelectX * this.canvas.width * this.backgroundWidthOfCanvas;
            let fgy = this.fixedGridSelectY * this.canvas.height * this.backgroundHeightOfCanvas;
            let fgw = this.selectionWidth * fgStep;
            let fgh = this.selectionHeight * fgStep;

            fgx = Math.floor(fgx);
            fgy = Math.floor(fgy);
            fgw = Math.floor(fgw);
            fgh = Math.floor(fgh);

            ctx.save();
            ctx.fillStyle = `rgba(0, 0, 0, 0.75)`;
            ctx.fillRect(fgx, fgy, fgw, fgh);
            ctx.translate(0.5, 0.5);

            ctx.strokeStyle = `black`;
            ctx.lineWidth = 5;
            ctx.strokeRect(fgx, fgy, fgw, fgh);

            if (this.isDraggingGridSelection) {
                ctx.strokeStyle = 'lime';
            } else if (this.isResizingGridSelection) {
                ctx.strokeStyle = 'yellow';
            } else {
                ctx.strokeStyle = 'white';
            }
            ctx.lineWidth = 3;
            ctx.strokeRect(fgx, fgy, fgw, fgh);

            ctx.setLineDash([]);
            ctx.strokeStyle = this.gridToolSelectionBackgroundColour;
            ctx.lineWidth = 1;
            for (let y = fgy + fgStep; y < fgy + fgh; y += fgStep) {
                ctx.beginPath();
                ctx.moveTo(fgx, y);
                ctx.lineTo(fgx + fgw, y);
                ctx.stroke();
            }
            for (let x = fgx + fgStep; x < fgx + fgw; x += fgStep) {
                ctx.beginPath();
                ctx.moveTo(x, fgy);
                ctx.lineTo(x, fgy + fgh);
                ctx.stroke();
            }

            ctx.restore();
        }

        ctx.save();
        let legendOffsetX = 16;
        let legendOffsetY = 8;
        let metreScale = ((fgStep / 320) * 1000);

        ctx.fillStyle = this.gridToolBackgroundColour;
        ctx.fillRect(legendOffsetX - 1, this.canvas.height - legendOffsetY - metreScale - 9, 6, metreScale + 2);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
        ctx.fillRect(legendOffsetX, this.canvas.height - legendOffsetY - 56, 108, 48);
        ctx.fillStyle = this.gridToolLegendColour;
        ctx.fillRect(legendOffsetX, this.canvas.height - legendOffsetY - metreScale - 8, 4, metreScale);
        ctx.fillText(`1 metre`, legendOffsetX + 8, this.canvas.height - legendOffsetY - 56 + 20);
        ctx.fillText(`(1 : ${Math.round((this.dpcm / metreScale) * 100)} scale)`, legendOffsetX + 8, this.canvas.height - legendOffsetY - 56 + 36);

        ctx.restore();
    }

    repaint() {
        if (this.gridFixedToImage) {
            this.repaint2();
            return;
        }
        /*
        let ctx = this.context;
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        ctx.fillStyle = this.gridToolBackgroundColour;
        ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        if (this.activeBackground) {
            ctx.save();
            ctx.translate(this.backgroundX * this.canvas.width, this.backgroundY * this.canvas.height);
            ctx.scale(this.backgroundScale, this.backgroundScale);
            try {
                //console.log(this.activeBackground);
                ctx.drawImage(this.activeBackground, 0, 0);
            } catch (err) {
                console.log(err);
                console.log(this.activeBackground);
            }
            ctx.restore();
        }

        let xStep = this.gridStep;
        let yStep = xStep;
        let legendOffsetX = 16;
        let legendOffsetY = 8;

        let metreScale = (yStep / 320) * 1000;

        let cellsWide = this.gridCellsWide;
        let cellsTall = this.gridCellsTall;
        let gridWidth = cellsWide * xStep;
        let gridHeight = cellsTall * yStep;

        ctx.fillStyle = this.gridToolGridLineColour;
        for (let x = this.gridOffsetX, i = 0; i <= cellsWide; x += xStep, i++) {
            ctx.fillRect(x, this.gridOffsetY, 1, gridHeight);
        }
        for (let y = this.gridOffsetY, i = 0; i <= cellsTall; y += yStep, i++) {
            ctx.fillRect(this.gridOffsetX, y, gridWidth, 1);
        }

        ctx.font = `12pt Play`;

        if (!this.isMeasuring) {
            ctx.fillStyle = this.gridToolBackgroundColour;
            ctx.fillRect(legendOffsetX - 1, this.canvas.height - legendOffsetY - metreScale - 9, 6, metreScale + 2);
            ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
            ctx.fillRect(legendOffsetX, this.canvas.height - legendOffsetY - 56, 108, 48);
            ctx.fillStyle = this.gridToolLegendColour;
            ctx.fillRect(legendOffsetX, this.canvas.height - legendOffsetY - metreScale - 8, 4, metreScale);
            ctx.fillText(`1 metre`, legendOffsetX + 8, this.canvas.height - legendOffsetY - 56 + 20);
            ctx.fillText(`(1 : ${Math.round((this.dpcm / metreScale) * 100)} scale)`, legendOffsetX + 8, this.canvas.height - legendOffsetY - 56 + 36);
        }

        let hoverCellX = this.hoverCellX * this.gridStep + this.gridOffsetX;
        let hoverCellY = this.hoverCellY * this.gridStep + this.gridOffsetX;

        ctx.save();
        ctx.strokeStyle = this.gridToolHoverBorderColour;
        ctx.lineWidth = 1;
        ctx.setLineDash([]);
        ctx.translate(0.5, 0.5);
        ctx.strokeRect(hoverCellX, hoverCellY, this.gridStep, this.gridStep);
        ctx.restore();

        ctx.save();
        ctx.strokeStyle = this.gridToolSelectionBorderColour;
        ctx.lineWidth = 1;
        ctx.setLineDash([8, 8]);
        ctx.lineDashOffset = -((new Date().getTime() / 100) % 16);
        ctx.fillStyle = this.gridToolSelectionBackgroundColour;
        ctx.fillRect(this.selectionX * this.gridStep + this.gridOffsetX, this.selectionY * this.gridStep + this.gridOffsetY, this.selectionWidth * this.gridStep, this.selectionHeight * this.gridStep);
        ctx.translate(0.5, 0.5);
        ctx.strokeRect(this.selectionX * this.gridStep + this.gridOffsetX, this.selectionY * this.gridStep + this.gridOffsetY, this.selectionWidth * this.gridStep, this.selectionHeight * this.gridStep);
        ctx.restore();

        ctx.fillStyle = this.gridToolLabelShadowColour;
        let tx = this.selectionX * this.gridStep + this.gridOffsetX;
        let ty = (this.selectionY + this.selectionHeight) * this.gridStep + this.gridOffsetY + 16;

        ctx.fillText(`${this.selectionWidth} x ${this.selectionHeight} modules`, tx + 1, ty + 1);
        ctx.fillText(`${Math.round(this.selectionWidth * 32) / 100}m x ${Math.round(this.selectionHeight * 32) / 100}m`, tx + 1, ty + 21);

        if (this.isMeasuring) {
            ctx.save();

            ctx.lineWidth = 4;
            ctx.strokeStyle = this.ddsbBrandBlueRgba(1);
            ctx.beginPath();
            ctx.moveTo(this.measureStartX * ctx.canvas.width, this.measureStartY * ctx.canvas.height);
            ctx.lineTo(this.measureToX * ctx.canvas.width, this.measureToY * ctx.canvas.height);
            ctx.stroke();

            //let label = `1 metre (1 : ${Math.min(72, Math.max(1, Math.round((this.dpcm / this.nominalMeasureScale) * 100)))})`;
            let label = `1 metre (1 : ${Math.round((this.dpcm / this.nominalMeasureScale) * 100)})`;
            let ms = ctx.measureText(label);

            let deltaX = this.measureStartX - this.measureToX;
            let deltaY = this.measureStartY - this.measureToY;

            let midX = ((this.measureStartX + this.measureToX) * 0.5 * ctx.canvas.width) - ms.width / 2;
            let midY = ((this.measureStartY + this.measureToY) * 0.5 * ctx.canvas.height) - (ms.actualBoundingBoxAscent + ms.actualBoundingBoxDescent) / 2;

            let delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            //console.log(`delta: ${delta}`);
            if (delta < 0.5) {
                midY += this.measureToY > 0.5 ? -32 : 32;
            }

            ctx.fillStyle = `rgba(255, 255, 255, 0.9)`;
            ctx.fillRect(midX - 8, midY - 8, ms.width + 16, (ms.actualBoundingBoxAscent + ms.actualBoundingBoxDescent) + 16);

            ctx.fillStyle = this.gridToolLegendColour;
            ctx.fillText(label, midX, midY + ms.actualBoundingBoxAscent);

            //console.log(`measure from [${this.measureStartX}, ${this.measureStartY}] to [${this.measureToX}, ${this.measureToY}]`);

            ctx.restore();
        }
        */
    }

    get previewQuoteImage() {
        if (!this.activeBackground) return null;

        let canvas = document.createElement('canvas');
        let aspect = this.canvas.width / this.canvas.height;
        canvas.width = DataTransferImageWidth;
        canvas.height = DataTransferImageWidth / aspect;
        let ctx = canvas.getContext('2d');
        ctx.drawImage(this.canvas, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL('jpeg', 30);

        /*
        let canvas = document.createElement('canvas');
        let aspect = this.activeBackground.naturalWidth / this.activeBackground.naturalHeight;

        canvas.width = DataTransferImageWidth;
        canvas.height = DataTransferImageWidth / aspect;

        console.log(`canvas height: ${canvas.height}`);
        console.log(`background scale: ${this.backgroundScale}`);
        console.log(`grid scale: ${this.gridScale}`);
        console.log(`active canvas size: ${this.canvas.width} x ${this.canvas.height}`);

        let activeCanvasHeightInM = this.canvas.height / this.metreScale;
        console.log(`active canvas height in m: ${activeCanvasHeightInM}`);

        let previewHeightInM = canvas.height / this.metreScale;
        console.log(`preview height in m: ${previewHeightInM}`);

        let activeCanvasGridHeight = activeCanvasHeightInM * 0.32;
        console.log(`active canvas grid height: ${activeCanvasGridHeight}`);
        let previewGridHeight = previewHeightInM * 0.32;
        console.log(`preview grid height: ${activeCanvasGridHeight}`);

        let bgScale = (this.canvas.height / canvas.height) / this.backgroundScale;
        let cellSize = (canvas.height / (previewGridHeight * this.gridCellsWide)) * bgScale;

        let windowWidth = cellSize * this.selectionWidth;
        let windowHeight = cellSize * this.selectionHeight;

        let bgX = this.backgroundX * canvas.width;
        let bgY = this.backgroundY * canvas.height;

        let windowX = (cellSize * this.selectionX) - (bgX);
        let windowY = (cellSize * this.selectionY) - (bgY);
        console.log(`background at: ${bgX}, ${bgY}`);

        let ctx = canvas.getContext('2d');
        ctx.drawImage(this.activeBackground, 0, 0, canvas.width, canvas.height);
        ctx.fillStyle = 'rgba(0, 0, 0, 0.75)';
        ctx.fillRect(windowX, windowY, windowWidth, windowHeight);
        ctx.strokeStyle = 'red';
        ctx.lineWidth = 2;
        ctx.strokeRect(windowX, windowY, windowWidth, windowHeight);

        return canvas.toDataURL('jpeg', 30);

        return null;
        */
    }

    logPreview() {
        app.logImage(this.previewQuoteImage);
    }
    logBackground() {
        app.logImage(this.activeBackground.src);
    }


    static init(ddsb: DDSB): SignDesigner {
        let container = Z.first('#sign-designer-app');
        if (!container) return null;

        app = ddsb;

        document.body.addEventListener('dblclick', ev => {
            SignDesigner.instance.logPreview();
        });

        SignDesigner.instance = new SignDesigner(container);
        return SignDesigner.instance;
    }

    private constructor(container: HTMLElement) {
        this.container = container;
        this.canvasContainer = Z.firstFrom(container, '.canvas-container');
        this.canvas = Z.firstFrom<HTMLCanvasElement>(container, 'canvas.sign-designer-canvas');
        this.context = this.canvas.getContext('2d');
        this.toolbar = Z.firstFrom(container, '.toolbar');

        //console.log(`Selection: ${this.selectionX}, ${this.selectionY}, ${this.selectionWidth}, ${this.selectionHeight}`);

        this.canvas.addEventListener('touchstart', ev => {
            if (ev.touches.length > 1) {
                this.canvasTouchStart(ev);
            }
        });
        this.canvas.addEventListener('touchmove', ev => {
            if (ev.changedTouches.length > 1) {
                this.canvasTouchMove(ev);
            }
        });
        this.canvas.addEventListener('touchend', ev => {
            if (ev.changedTouches.length > 1) {
                this.canvasTouchEnd(ev);
            }
        });
        new ContainedDragListener(this.canvas);

        this.canvas.addEventListener('cursor-hover', ev => this.cursorHover(ev as ContainedDragEvent));
        this.canvas.addEventListener('cursor-start', ev => this.cursorStart(ev as ContainedDragEvent));
        this.canvas.addEventListener('cursor-move', ev => this.cursorMove(ev as ContainedDragEvent));
        this.canvas.addEventListener('cursor-stop', ev => this.cursorEnd(ev as ContainedDragEvent));
        this.canvas.addEventListener('wheel', ev => this.mouseWheel(ev as WheelEvent));

        document.addEventListener('resize', ev => this.resize());

        /* Z.forEach('[data-select-quote-background-image]', el => {
            el.addEventListener('click', ev => {
                let imgSrc = `/img/stock/signbg/${el.dataset.selectQuoteBackgroundImage}`;
                let img = document.createElement('img');
                img.onload = loaded => {
                    this.showImageSelectModal(img);
                    //this.selectBackground(img);
                };
                img.src = imgSrc;
            });
        }); */

        Z.forEach('.upload-quote-background-image-button', el => {
            el.addEventListener('click', ev => Z.forFirst('#quote-upload-file', el => el.click()));
        });

        Z.forEach('.camera-quote-background-image-button', el => {
            el.addEventListener('click', ev => {
                this.checkUserMedia();
            });
        });

        Z.forFirst<HTMLVideoElement>('video#webcam-capture', el => {
            el.addEventListener('click', ev => {
                this.captureWebcam();
            });
        });

        Z.forFirst<HTMLInputElement>('#quote-upload-file', el => {
            el.addEventListener('change', ev => {
                if (el.files.length) {
                    const file = el.files[0];
                    if (file.type.startsWith('image/')) {
                        let img = document.createElement('img');
                        img.onload = ev => {
                            //this.selectBackground(img);
                            this.showImageSelectModal(img);
                        };
                        const reader = new FileReader();
                        reader.onload = ev => {
                            img.src = <string>ev.target.result;
                            el.value = null;
                        };
                        reader.readAsDataURL(file);
                        el.files = null;
                        el.value = null;
                    }
                }
            });
        });

        Z.forEach('.remove-quote-background-image-button', el => {
            el.addEventListener('click', ev => {
                this.selectBackground(null);
            });
        });

        Z.forEach('[data-quote-gui-tool]', el => {
            el.addEventListener('click', ev => {
                Z.forEach('[data-quote-gui-tool]', el => el.classList.remove('active'));
                el.classList.add('active');
                this.canvas.dataset.tool = this.activeTool;
            });
        });

        Z.init('#photo-selection-modal button.dismiss-photo-selection-modal', 'psm-dismiss', btn => {
            btn.addEventListener('click', ev => this.dismissImageModalSelection());
        });
        Z.init('#photo-selection-modal button.accept-photo-selection-modal', 'psm-accept', btn => {
            btn.addEventListener('click', ev => this.acceptImageModalSelection());
        });

        if (window['ResizeObserver']) {
            let observer = new window['ResizeObserver'](ev => {
                document.dispatchEvent(new Event('resize'));
            });
            observer.observe(document.body);
        }

        Z.init('#photo-selection-modal', 'psm', modal => this.initPhotoSelectionModal());

        window.requestAnimationFrame(t => this.animate(t));

        this.resize();

        let bgSrc = Z.valueOf('#SelectedBackgroundBase64', '');
        if (bgSrc && bgSrc.startsWith('data:image')) {
            //console.log(`loading prior background image:`, bgSrc);
            let imgSrc = bgSrc;
            let img = document.createElement('img');
            img.onload = loaded => {
                this.selectBackground(img, false);
            };
            img.src = imgSrc;
        }

        /*while (this.gridCellsTall < 10 || this.gridCellsWide < 10) {
            this.gridScale -= 0.01;
            this.repaint();
        }*/

        Z.init('.select-picture-tool', 'photo-select-tool', el => {
            el.addEventListener('click', ev => {
                if (el.classList.contains('upload')) {
                    Z.dismissModal();
                    this.imageSelectTool = 'crop';
                    Z.forFirst('#quote-upload-file', el => el.click());
                } else if (el.classList.contains('camera')) {
                    Z.dismissModal();
                    this.imageSelectTool = 'capture';
                    this.checkUserMedia();
                } else if (el.classList.contains('template')) {
                    if (false) {
                        Z.forEach<HTMLImageElement>('#default-sign-bg-image-2', img => {
                            console.log(`${el.dataset.selectQuoteBackgroundImage} => ${el.dataset.scale}`);
                            img.src = `/img/standard-images/${el.dataset.selectQuoteBackgroundImage}`;
                            this.gridFixedMetreScale = parseFloat(el.dataset.scale);
                            this.repaint();
                            this.resize(true);
                            this.fixedGridSelectX = -1;
                            this.fixedGridSelectY = -1;
                            this.fixedGridSelectWidth = 0;
                            this.fixedGridSelectHeight = 0;

                            this.onDiff();
                        });
                    } else {
                        let imgSrc = `/img/standard-images/${el.dataset.selectQuoteBackgroundImage}`;
                        let img = document.createElement('img');
                        img.onload = loaded => {
                            // TODO: preset scale
                            //this.showImageSelectModal(img);

                            let cvs = document.createElement('canvas');
                            cvs.width = DataTransferImageWidth;
                            cvs.height = DataTransferImageWidth;
                            let ctx = cvs.getContext('2d');
                            ctx.clearRect(0, 0, cvs.width, cvs.height);
                            ctx.drawImage(Z.first<HTMLImageElement>('#default-sign-bg-image-1'), 0, 0, cvs.width, cvs.height);
                            ctx.drawImage(img, 0, 0, cvs.width, cvs.height);
                            let img2 = document.createElement('img');
                            img2.onload = loaded => {
                                this.selectBackground(img2);
                                this.gridFixedMetreScale = parseFloat(el.dataset.scale);
                                this.repaint();
                                this.resize(true);

                                this.fixedGridSelectX = -1;
                                this.fixedGridSelectY = -1;
                                this.fixedGridSelectWidth = 0;
                                this.fixedGridSelectHeight = 0;
                            };
                            img2.src = cvs.toDataURL('jpeg', 100);
                        };
                        img.src = imgSrc;
                    }
                    Z.dismissModal();
                }
            });
        });
    }

    get photoSelectionModal(): HTMLElement { return Z.one('#photo-selection-modal'); }
    photoSelectionCanvas: HTMLCanvasElement;
    photoSelectionContext: CanvasRenderingContext2D;

    cropToolX: number;
    cropToolY: number;
    cropToolW: number;
    cropToolH: number;

    scaleToolX: number;
    scaleToolY: number;
    scaleToolX2: number;
    scaleToolY2: number;

    originalRotateValue: number = 0;
    rotateValue: number = 0;

    //fixedGridSelectX: number = 0;
    //fixedGridSelectY: number = 0;
    fixedGridSelectWidth: number = 0;
    fixedGridSelectHeight: number = 0;

    get fixedGridSelectX() {
        let nominal = parseFloat(Z.valueOf('#FixedGridSelectX', '-1'));
        if (nominal <= 0 || isNaN(nominal)) nominal = -1;
        return nominal;
    }
    set fixedGridSelectX(to: number) {
        if (to < 0 || isNaN(to)) to = 0;
        Z.setValue('#FixedGridSelectX', to.toString(), true);
    }
    get fixedGridSelectY() {
        let nominal = parseFloat(Z.valueOf('#FixedGridSelectY', '-1'));
        if (nominal <= 0 || isNaN(nominal)) nominal = -1;
        return nominal;
    }
    set fixedGridSelectY(to: number) {
        if (to < 0 || isNaN(to)) to = 0;
        Z.setValue('#FixedGridSelectY', to.toString(), true);
    }

    get photoToolImage(): HTMLImageElement {
        return <HTMLImageElement>Z.getData(this.photoSelectionModal, 'image');
    }
    set photoToolImage(to: HTMLImageElement) {
        Z.setData(this.photoSelectionModal, 'image', to);
        this.redrawImageSelectModal();
    }

    get imageSelectTool(): 'zoom' | 'crop' | 'rotate' | 'scale' | 'capture' | string
    {
        return <'zoom' | 'crop' | 'rotate' | 'scale' | 'capture' | string>Z.first(`#photo-selection-modal .photo-select-tools [data-ps-tool].active`).dataset.psTool;
    }
    set imageSelectTool(to: 'zoom' | 'crop' | 'rotate' | 'scale' | 'capture' | string) {
        Z.forEach(`#photo-selection-modal .photo-select-tools [data-ps-tool].active`, btn => btn.classList.remove('active'));
        Z.forEach(`#photo-selection-modal .photo-select-tools [data-ps-tool="${to}"]`, btn => btn.classList.add('active'));
        this.redrawImageSelectModal();
    }
    initPhotoSelectionModal() {
        this.photoSelectionCanvas = Z.oneFrom<HTMLCanvasElement>(this.photoSelectionModal, 'canvas');
        this.photoSelectionContext = this.photoSelectionCanvas?.getContext('2d');

        new ContainedDragListener(this.photoSelectionCanvas);

        Z.init('.skip-crop-stage-btn', 'skip-crop', btn => {
            btn.addEventListener('click', ev => {
                this.cropToolToImageScale();
                this.acceptPhotoSelectionTool();
                ev.preventDefault();
                ev.stopPropagation();
            });
        });

        Z.init('#photo-selection-modal .accept-tool-icon button.accept', 'accept', btn => {
            btn.addEventListener('click', ev => {
                this.acceptPhotoSelectionTool();
                Z.forEach('.accept-tool-icon', e => e.classList.remove('active'));
            });
        });
        Z.init('#photo-selection-modal .accept-tool-icon button.cancel', 'cancel', btn => {
            btn.addEventListener('click', ev => {
                this.cancelPhotoSelectionTool();
                Z.forEach('.accept-tool-icon', e => e.classList.remove('active'));
            });
        });

        this.photoSelectionCanvas.addEventListener('cursor-start', (ev: ContainedDragEvent) => {
            if (this.imageSelectTool == 'crop') {
                this.cropToolX = ev.x;
                this.cropToolY = ev.y;
                this.cropToolW = 0;
                this.cropToolH = 0;
            }
            if (this.imageSelectTool == 'scale') {
                this.scaleToolX = ev.x;
                this.scaleToolY = ev.y;
                this.scaleToolX2 = ev.x;
                this.scaleToolY2 = ev.y;
            }

            Z.forEach(`.accept-tool-icon`, div => div.classList.remove('active'));
            this.redrawImageSelectModal();
        });
        this.photoSelectionCanvas.addEventListener('cursor-move', (ev: ContainedDragEvent) => {
            if (this.imageSelectTool == 'crop') {
                this.cropToolW = ev.x - this.cropToolX;
                this.cropToolH = ev.y - this.cropToolY;
            }

            if (this.imageSelectTool == 'rotate') {
                this.rotateValue = this.originalRotateValue + ev.deltaX * (Math.PI / 2);
            }

            if (this.imageSelectTool == 'scale') {
                this.scaleToolX2 = ev.x;
                this.scaleToolY2 = ev.y;
            }

            this.redrawImageSelectModal();
        });
        this.photoSelectionCanvas.addEventListener('cursor-stop', (ev: ContainedDragEvent) => {
            if (isNaN(ev.delta) || ev.delta < 0.01 || !ev.isInsideElement || Z.any('.stage-tools button:hover, button:active')) {
                this.cancelPhotoSelectionTool();
                return;
            }
            //console.log(`ev.delta: ${ev.delta}, ${ev.deltaX}, ${ev.deltaY} | ${ev.isInsideElement}`);
            if (this.imageSelectTool == 'rotate') {
                this.originalRotateValue = this.rotateValue;
                Z.forEach(`.accept-tool-icon`, div => div.classList.add('active'));
            } else if (this.imageSelectTool == 'crop') {
                Z.forEach(`.accept-tool-icon`, div => div.classList.add('active'));
            } else if (this.imageSelectTool == 'scale') {
                Z.forEach(`.accept-tool-icon`, div => div.classList.add('active'));
                this.calculateScaleTool();
            }
        });

        Z.init(`#photo-selection-modal .photo-select-tools [data-ps-tool]`, 'pstool', btn => {
            btn.addEventListener('click', ev => this.imageSelectTool = btn.dataset.psTool);
        });

        Z.init(`#photo-selection-modal .photo-select-tools [data-rotate-tool]`, 'rotate-tool', btn => {
            btn.addEventListener('click', ev => this.rotatePhotoTool(parseInt(btn.dataset.rotateTool)));
        });

        if (window['ResizeObserver']) {
            let resizeObserver = new window['ResizeObserver'](cb => {
                this.redrawImageSelectModal();
            });

            resizeObserver.observe(this.photoSelectionModal);
        }
    }

    calculateScaleTool() {
        // TODO: calculate somehow

        /*
        let x1 = this.scaleToolX;
        let y1 = this.scaleToolY;
        let x2 = this.scaleToolX2;
        let y2 = this.scaleToolY2;

        let width = this.photoSelectionCanvas.width;
        let height = this.photoSelectionCanvas.height;
        let widthScale = 1;
        let heightScale = 1;

        if (this.photoToolImage && this.photoToolImage.naturalWidth) {
            let photoBounds = CanvasUtils.bestFit({ width: this.photoToolImage.naturalWidth, height: this.photoToolImage.naturalHeight }, this.photoSelectionCanvas);
            console.log(`photobounds (whole): ${photoBounds}`);
            width = Math.round(photoBounds.width);
            height = Math.round(photoBounds.height);

            let xScale = this.photoSelectionCanvas.width;
            let yScale = this.photoSelectionCanvas.height;

            let pbb = new Dimension(photoBounds);
            pbb.x /= xScale;
            pbb.y /= yScale;
            pbb.width /= xScale;
            pbb.height /= yScale;

            console.log(`photobounds (fract): ${pbb}`);

            widthScale = pbb.width;
            heightScale = pbb.height;
        }

        let dx = Math.abs(x2 - x1);
        let dy = Math.abs(y2 - y1);
        let dxy = Math.max(dx, dy);
        console.log(`dx: ${CanvasUtils.round(dx)}, dy: ${CanvasUtils.round(dy)}, dxy: ${CanvasUtils.round(dxy)} (major delta is ${dxy == dx ? 'X' : 'Y'})`);

        //let deltaX = dxy / scalar;
        //let deltaY = dxy / scalar;
        let deltaX = dx / widthScale;
        let deltaY = dy / heightScale;

        let deltaXB = dy / widthScale;
        let deltaYB = dx / heightScale;

        console.log(`deltas A (x: ${CanvasUtils.round(deltaX)}, y: ${CanvasUtils.round(deltaY)})`);
        console.log(`deltas B (x: ${CanvasUtils.round(deltaXB)}, y: ${CanvasUtils.round(deltaYB)})`);

        deltaX = Math.max(deltaX, deltaXB);
        deltaY = Math.max(deltaY, deltaYB);

        //width *= widthScale;
        //height *= heightScale;

        let round = (n: number) => Math.round(n * 100) / 100;

        console.log(`canvas size: ${this.photoSelectionCanvas.width} x ${this.photoSelectionCanvas.height}`);
        console.log(`imagen size: ${this.photoToolImage.naturalWidth} x ${this.photoToolImage.naturalHeight}`);
        console.log(`scaled size: ${width} x ${height}`);
        console.log(`relative scale: ${round(widthScale)} x ${round(heightScale)}`);

        //let deltaX2 = deltaX * this.photoSelectionCanvas.width;
        //let deltaY2 = deltaY * this.photoSelectionCanvas.height;

        // <--- ????
        //deltaX = Math.max(deltaX, deltaY);
        //deltaY = deltaX;

        let deltaX2 = deltaX * width;
        let deltaY2 = deltaY * height;

        //let delta = Math.sqrt(deltaX2 * deltaX2 + deltaY2 * deltaY2);

        //delta2 = deltaX;
        //delta = delta2;

        console.log(`deltaX: ${round(deltaX)}, deltaY: ${round(deltaY)}`);
        //console.log(`delta: ${round(delta)}`);
        //let metreScaleX = (width / delta);
        //let metreScaleY = (height / delta);
        //let metreScaleX = (this.photoSelectionCanvas.width / delta);
        //let metreScaleY = (this.photoSelectionCanvas.height / delta);
        //let metreScaleX = (width / deltaX2);
        //let metreScaleY = (height / deltaY2);
        */

        let metreScaleX = 1 / this.nominalMeasureScaleX;
        let metreScaleY = 1 / this.nominalMeasureScaleY;

        console.log(`metre scale: x = ${Math.round(metreScaleX * 100) / 100}, y = ${Math.round(metreScaleY * 100) / 100}`);
        this.photoSelectionModal.dataset.metreScaleX = metreScaleX.toString();
        this.photoSelectionModal.dataset.metreScaleY = metreScaleY.toString();

        //this.photoSelectionModal.dataset.metreScale = delta.toString();
        this.photoSelectionModal.dataset.metreScale = metreScaleX.toString();
    }

    backgroundWidthOfCanvas: number = 1;
    backgroundHeightOfCanvas: number = 1;

    rotatePhotoTool(angle: number) {
        //console.log(`rotate photo tool ${angle}`);

        let img = <HTMLImageElement>Z.getData(this.photoSelectionModal, 'image');
        if (!img || !img.naturalWidth || !img.naturalHeight) {
            //console.log(`err:`, img, img.naturalWidth, img.naturalHeight);
            return;
        }
        let width = img.naturalWidth;
        let height = img.naturalHeight;

        let canvas = document.createElement('canvas');
        canvas.width = height;
        canvas.height = width;
        let ctx = canvas.getContext('2d');

        ctx.scale(canvas.width, canvas.height);

        ctx.translate(0.5, 0.5);
        if (angle == -90) {
            ctx.rotate(-Math.PI / 2);
        } else if (angle == 90) {
            ctx.rotate(Math.PI / 2);
        }
        ctx.drawImage(img, -0.5, -0.5, 1, 1);

        let newImg = document.createElement('img');
        let src = canvas.toDataURL();

        newImg.onload = ev => {
            Z.setData(this.photoSelectionModal, 'image', newImg);
            this.redrawImageSelectModal();
        };

        newImg.src = src;
    }

    get photoToolBounds(): Dimension {
        if (this.photoToolImage && this.photoToolImage.naturalWidth) {
            let inner = { width: this.photoToolImage.naturalWidth, height: this.photoToolImage.naturalHeight };
            let outer = { width: this.photoSelectionCanvas.width, height: this.photoSelectionCanvas.height };
            return CanvasUtils.bestFit(inner, outer);
        }
        return null;
    }

    redrawImageSelectModal(withgui: boolean = true) {
        let canvas = this.photoSelectionCanvas;
        if (!canvas) return;

        canvas.width = canvas.getBoundingClientRect().width;
        canvas.height = canvas.getBoundingClientRect().height;

        let ctx = this.photoSelectionContext;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        let img = <HTMLImageElement>Z.getData(this.photoSelectionModal, 'image');

        if (img) {
            img.width = img.naturalWidth;
            img.height = img.naturalHeight;

            let bounds = CanvasUtils.bestFit({ width: img.naturalWidth, height: img.naturalHeight }, canvas);

            ctx.save();
            //ctx.fillStyle = `rgba(0, 0, 0, 0.85)`;
            ctx.fillStyle = `rgba(255, 255, 255, 0.85)`;
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 2;
            ctx.translate(canvas.width * 0.5, canvas.height * 0.5);
            ctx.rotate(this.rotateValue);
            ctx.fillRect(bounds.width * -0.5, bounds.height * -0.5, bounds.width, bounds.height);
            ctx.strokeRect(bounds.width * -0.5, bounds.height * -0.5, bounds.width, bounds.height);
            ctx.drawImage(img, bounds.width * -0.5, bounds.height * -0.5, bounds.width, bounds.height);

            //ctx.strokeStyle = `red`;
            //ctx.lineWidth = 4;
            //ctx.strokeRect(bounds.width * -0.5, bounds.height * -0.5, bounds.width, bounds.height);

            ctx.restore();
        }

        if (withgui) {
            if (this.imageSelectTool == 'crop') {
                let x = this.cropToolX;
                let y = this.cropToolY;
                let w = this.cropToolW;
                let h = this.cropToolH;
                if (w < 1 || h < 1) {
                    ctx.save();
                    ctx.translate(0.5, 0.5);
                    ctx.fillStyle = `rgba(0, 0, 0, 0.75)`;

                    if (w < 0) {
                        x += w;
                        w = -w;
                    }
                    if (h < 0) {
                        y += h;
                        h = -h;
                    }

                    ctx.fillRect(0, 0, canvas.width, canvas.height * y);
                    ctx.fillRect(0, canvas.height * (y + h), canvas.width, canvas.height);

                    ctx.fillRect(0, canvas.height * y, canvas.width * x, canvas.height * h);
                    ctx.fillRect(canvas.width * (x + w), canvas.height * y, canvas.width, canvas.height * h);

                    ctx.strokeStyle = `white`;
                    ctx.lineWidth = 3;
                    ctx.beginPath();
                    ctx.rect(x * canvas.width, y * canvas.height, w * canvas.width, h * canvas.height);
                    ctx.stroke();

                    ctx.save();
                    let fx = w * 0.2;
                    let fy = h * 0.2;
                    ctx.fillStyle = `rgba(0, 0, 0, 0.5)`;
                    ctx.fillRect((x + fx) * canvas.width, (y + fy) * canvas.height, (w - fx * 2) * canvas.width, (h - fy * 2) * canvas.height);
                    ctx.strokeStyle = `rgba(255, 255, 255, 0.75)`;
                    ctx.lineWidth = 1;
                    ctx.strokeRect((x + fx) * canvas.width, (y + fy) * canvas.height, (w - fx * 2) * canvas.width, (h - fy * 2) * canvas.height);
                    ctx.restore();

                    ctx.restore();
                }
            }

            if (this.imageSelectTool == 'rotate') {
                ctx.strokeStyle = 'white';
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(16, canvas.height - 16);
                ctx.lineTo(canvas.width - 16, canvas.height - 16);
                ctx.stroke();
            }

            if (this.imageSelectTool == 'scale') {
                ctx.save();

                let x1 = this.scaleToolX * canvas.width;
                let y1 = this.scaleToolY * canvas.height;
                let x2 = this.scaleToolX2 * canvas.width;
                let y2 = this.scaleToolY2 * canvas.height;

                let deltaX = x2 - x1;
                let deltaY = y2 - y1;
                //let delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                let delta = Math.max(deltaX, deltaY);
                if (delta > 32) {
                    ctx.save();
                    let deltaGrid = delta * 0.333333333;
                    ctx.strokeStyle = `rgba(0, 0, 0, ${Math.max(Math.min(delta - 32, 100), 0) / 200})`;

                    let hline = (y) => {
                        ctx.beginPath();
                        ctx.moveTo(0, y);
                        ctx.lineTo(canvas.width, y);
                        ctx.stroke();
                    };
                    let vline = (x) => {
                        ctx.beginPath();
                        ctx.moveTo(x, 0);
                        ctx.lineTo(x, canvas.height);
                        ctx.stroke();
                    };
                    ctx.setLineDash([8, 8]);
                    for (let y = y1; y <= canvas.height; y += deltaGrid) hline(y);
                    for (let y = y1; y >= 0; y -= deltaGrid) hline(y);

                    for (let x = x1; x <= canvas.width; x += deltaGrid) vline(x);
                    for (let x = x1; x >= 0; x -= deltaGrid) vline(x);

                    ctx.lineWidth = 3;
                    deltaGrid = delta;
                    ctx.strokeStyle = `rgba(0, 0, 0, ${Math.max(Math.min(delta - 32, 100), 0) / 100})`;
                    ctx.setLineDash([]);
                    for (let y = y1; y <= canvas.height; y += deltaGrid) hline(y);
                    for (let y = y1; y >= 0; y -= deltaGrid) hline(y);

                    for (let x = x1; x <= canvas.width; x += deltaGrid) vline(x);
                    for (let x = x1; x >= 0; x -= deltaGrid) vline(x);

                    ctx.restore();

                    let ptb = this.photoToolBounds;
                    //console.log(`deltaGrid: ${deltaGrid} of ${ptb.width} x ${ptb.height} (${CanvasUtils.round(ptb.width / deltaGrid)} x ${CanvasUtils.round(ptb.height / deltaGrid)})`);
                    this.nominalMeasureScaleX = ptb.width / deltaGrid;
                    this.nominalMeasureScaleY = ptb.height / deltaGrid;
                }

                ctx.strokeStyle = 'black';
                ctx.lineWidth = 7;
                ctx.setLineDash([]);
                ctx.lineCap = 'round';
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();

                ctx.strokeStyle = 'white';
                ctx.setLineDash([8, 8]);
                ctx.lineWidth = 4;
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();

                ctx.fillStyle = `white`;
                ctx.beginPath();
                ctx.ellipse(x2, y2 - 8, 16, 16, 0, 0, Math.PI * 2, false);
                ctx.fill();
                ctx.strokeStyle = 'black';
                ctx.lineWidth = 3;
                ctx.setLineDash([]);
                ctx.stroke();

                ctx.strokeStyle = 'black';
                ctx.lineWidth = 3;
                ctx.setLineDash([]);
                ctx.beginPath();
                ctx.moveTo(x2, y2 - 8);
                let angle = delta / -12;
                let tagLength = 16;
                ctx.lineTo(x2 + Math.sin(angle) * tagLength, (y2 - 8) + Math.cos(angle) * tagLength);
                ctx.stroke();

                ctx.beginPath();
                ctx.lineWidth = 2;
                ctx.ellipse(x2, y2 - 8, 8, 8, 0, 0, Math.PI * 2, false);
                ctx.fillStyle = 'white';
                ctx.fill();
                ctx.stroke();

                ctx.restore();
            }
        }
        
    }

    acceptPhotoSelectionTool() {
        let src = <HTMLImageElement>Z.getData(this.photoSelectionModal, 'image');
        if (!src) return;

        if (this.imageSelectTool == 'crop') {
            let snip = document.createElement('canvas');
            this.redrawImageSelectModal(false);
            let scaleX = this.photoSelectionCanvas.width;
            let scaleY = this.photoSelectionCanvas.height;
            snip.width = scaleX * this.cropToolW;
            snip.height = scaleY * this.cropToolH;
            let ctx = snip.getContext('2d');
            ctx.drawImage(this.photoSelectionCanvas, this.cropToolX * scaleX, this.cropToolY * scaleY, this.cropToolW * scaleX, this.cropToolH * scaleY, 0, 0, snip.width, snip.height);
            let img = document.createElement('img');
            img.onload = () => {
                img.width = img.naturalWidth;
                img.height = img.naturalHeight;
                Z.setData(this.photoSelectionModal, 'image', img);
                this.cropToolToImageScale();
                this.redrawImageSelectModal();

                Z.forEach('#photo-selection-modal .step', step => step.classList.add('d-none'));
                Z.forEach('#photo-selection-modal .step-2', step => step.classList.remove('d-none'));
                Z.forEach('#photo-selection-modal .photo-select-tools', div => div.classList.add('d-none'));

                this.imageSelectTool = 'scale';
            };
            img.src = snip.toDataURL();
        }
        else if (this.imageSelectTool == 'rotate') {
            let snip = document.createElement('canvas');
            let scaleX = src.naturalWidth;
            let scaleY = src.naturalHeight;
            snip.width = scaleX;
            snip.height = scaleY;
            let ctx = snip.getContext('2d');
            ctx.translate(scaleX * 0.5, scaleY * 0.5);
            ctx.rotate(this.rotateValue);
            ctx.drawImage(src, 0, 0, scaleX, scaleY, scaleX * -0.5, scaleY * -0.5, scaleX, scaleY);
            //ctx.drawImage(src, this.cropToolX * scaleX, this.cropToolY * scaleY, this.cropToolW * scaleX, this.cropToolH * scaleY, 0, 0, snip.width, snip.height);
            let img = document.createElement('img');
            img.onload = () => {
                img.width = img.naturalWidth;
                img.height = img.naturalHeight;
                Z.setData(this.photoSelectionModal, 'image', img);
                this.cropToolToImageScale();
                this.rotateValue = 0;
                this.originalRotateValue = 0;
                this.redrawImageSelectModal();
            };
            img.src = snip.toDataURL();
        } else if (this.imageSelectTool == 'scale') {
            this.calculateScaleTool();
            Z.forFirst('.accept-photo-selection-modal', btn => btn.click());
        }
    }

    cropToolToImageScale() {
        this.cropToolX = 0;
        this.cropToolY = 0;
        this.cropToolW = 1;
        this.cropToolH = 1;

        if (this.photoToolImage && this.photoToolImage.naturalWidth) {
            let width = this.photoToolImage.naturalWidth;
            let height = this.photoToolImage.naturalHeight;

            let bounds = CanvasUtils.bestFit({ width: width, height: height }, this.photoSelectionCanvas);
            let scaleX = bounds.width / this.photoSelectionCanvas.width;
            let scaleY = bounds.height / this.photoSelectionCanvas.height;

            this.cropToolX = bounds.x / this.photoSelectionCanvas.width;
            this.cropToolY = bounds.y / this.photoSelectionCanvas.height;
            this.cropToolW = scaleX;
            this.cropToolH = scaleY;
        }

        //console.log(`crop to [${CanvasUtils.round(this.cropToolX)}, ${CanvasUtils.round(this.cropToolY)}] - [${CanvasUtils.round(this.cropToolW)} x ${CanvasUtils.round(this.cropToolH)}]`);
    }

    cancelPhotoSelectionTool() {
        if (this.imageSelectTool == 'crop') {
            this.cropToolToImageScale();
        }
        if (this.imageSelectTool == 'rotate') {
            this.originalRotateValue = 0;
            this.rotateValue = 0;
        }
        Z.forEach(`.accept-tool-icon`, div => div.classList.remove('active'));
        this.redrawImageSelectModal();
    }

    showImageSelectModal(img: HTMLImageElement) {

        this.cropToolToImageScale();

        this.scaleToolX = 0;
        this.scaleToolY = 0;
        this.scaleToolX2 = 0;
        this.scaleToolY2 = 0;

        this.originalRotateValue = 0;
        this.rotateValue = 0;

        this.photoSelectionModal.dataset.metreScaleX = '5';
        this.photoSelectionModal.dataset.metreScaleY = '5';
        this.photoSelectionModal.dataset.metreScale = '1';

        Z.forEach(`.accept-tool-icon`, div => div.classList.remove('active'));
        Z.forEach('#photo-selection-modal .step', step => step.classList.add('d-none'));
        Z.forEach('#photo-selection-modal .photo-select-tools', div => div.classList.add('d-none'));

        if (img) {
            // uploaded photo
            Z.forEach('#photo-selection-modal .step-1', step => step.classList.remove('d-none'));
            Z.forEach('#photo-selection-modal .photo-select-tools', div => div.classList.remove('d-none'));
        } else {
            // camera
        }

        Z.setData(this.photoSelectionModal, 'image', img);
        Z.forEach<HTMLImageElement>('#photo-selection-image', i => i.src = img.src);
        Z.showModal('#photo-selection-modal', null, null, modal => {
            this.redrawImageSelectModal();
            //this.activeTool = 'select';
        });
    }
    acceptImageModalSelection() {
        console.log(`[accept]`);
        let img = <HTMLImageElement>Z.getData(this.photoSelectionModal, 'image');
        console.log(img);
        this.selectBackground(img, false);

        let metreScaleX = parseFloat(this.photoSelectionModal.dataset.metreScaleX);
        let metreScaleY = parseFloat(this.photoSelectionModal.dataset.metreScaleY);

        console.log(`scale: ${metreScaleX} x ${metreScaleY} | ${this.photoSelectionModal.dataset.metreScale}`);
        //this.metreScale = parseFloat(this.photoSelectionModal.dataset.metreScale || '1') * 100;
        //this.gridScale = parseFloat(this.photoSelectionModal.dataset.metreScale || '1') * this.backgroundScale;
        /*
        this.backgroundX = 0;
        this.backgroundY = 0;
        this.backgroundScale = this.canvas.width / this.backgroundWidth;
        */

        this.gridFixedMetreScale = parseFloat(this.photoSelectionModal.dataset.metreScale || '1');

        this.fixedGridSelectX = -1;
        this.fixedGridSelectY = -1;
        this.fixedGridSelectWidth = 0;
        this.fixedGridSelectHeight = 0;

        this.repaint();

        Z.dismissModal();
        //this.activeTool = 'select';
    }
    dismissImageModalSelection() {
        Z.dismissModal();
    }

    canvasTouchStart(ev: TouchEvent) {
        if (ev.touches.length > 1) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    }
    touchZoomDelta: number = 0;
    canvasTouchMove(ev: TouchEvent) {
        if (ev.changedTouches.length > 1) {
            let deltaX = ev.changedTouches[0].clientX - ev.changedTouches[1].clientX;
            let deltaY = ev.changedTouches[0].clientY - ev.changedTouches[1].clientY;
            let pinch = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            let delta = pinch - this.touchZoomDelta;

            if (this.activeTool == 'scale') {
                if (delta > 0) {
                    this.mouseWheel(new WheelEvent('wheel', { deltaY: -1 }));
                } else if (delta < 0) {
                    this.mouseWheel(new WheelEvent('wheel', { deltaY: 1 }));
                }
            } else {
                if (delta > 0) {
                    this.mouseWheel(new WheelEvent('wheel', { deltaY: 1 }));
                } else if (delta < 0) {
                    this.mouseWheel(new WheelEvent('wheel', { deltaY: -1 }));
                }
            }

            this.touchZoomDelta = pinch;
            ev.preventDefault();
            ev.stopPropagation();
        }
    }
    canvasTouchEnd(ev: TouchEvent) {
        if (ev.changedTouches.length > 1) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    }

    mouseWheel(ev: WheelEvent): any {
        //console.log(`wheel: ${this.activeTool}`);
        if (this.activeTool == 'scale') {
            /*
            if (ev.deltaY < 0) this.gridScale *= 1.05;
            if (ev.deltaY > 0) this.gridScale *= 0.95;

            if (this.gridScale < 0.5) this.gridScale = 0.5;
            if (this.gridScale > 10) this.gridScale = 10;
            */

        } else if (this.activeTool == 'background') {
            let oldScale = this.backgroundScale;
            if (ev.deltaY > 0) this.backgroundScale *= 1.05;
            if (ev.deltaY < 0) this.backgroundScale *= 0.95;
            if (isNaN(this.backgroundScale) || this.backgroundScale === Infinity) this.backgroundScale = 1;

            let delta = this.backgroundScale - oldScale;
            this.backgroundX -= delta * 0.5;
            this.backgroundY -= delta * 0.5;
        }
        this.repaint();
        ev.preventDefault();
        ev.stopPropagation();
    }

    lastRenderTime: number = 0;
    animate(time: number) {
        //console.log(time - this.lastRenderTime);
        if (time - this.lastRenderTime > 10) {
            this.lastRenderTime = time;
            this.repaint();
        }
        window.requestAnimationFrame(t => this.animate(t));
    }

    setBg(x: number, y: number, scale: number = null) {
        //this.backgroundScale = scale ?? this.backgroundScale;
        //if (isNaN(this.backgroundScale) || this.backgroundScale === Infinity) this.backgroundScale = 1;
        //this.backgroundX = x;
        //this.backgroundY = y;
        this.repaint();
    }

    selectBackground(img: HTMLImageElement | null, autoScale: boolean = true) {
        if (img) {
            Z.forEach('.hide-when-selected-background', el => el.classList.add('d-none'));

            let cvs = document.createElement('canvas');
            let aspect = img.naturalWidth / img.naturalHeight;
            cvs.width = DataTransferImageWidth;
            cvs.height = DataTransferImageWidth / aspect;
            let ctx = cvs.getContext('2d');
            ctx.drawImage(img, 0, 0, cvs.width, cvs.height);

            if (autoScale) {
                let scaleX = 1 / (cvs.width / this.canvas.width);
                let scaleY = 1 / (cvs.height / this.canvas.height);
                this.backgroundScale = Math.min(scaleX, scaleY);
                if (isNaN(this.backgroundScale) || this.backgroundScale === Infinity) this.backgroundScale = 1;
                this.backgroundX = 0;
                this.backgroundY = 0;
            }

            Z.forEach<HTMLButtonElement>('.disable-when-background-selected', el => el.disabled = true);
            Z.forEach<HTMLButtonElement>('.enable-when-background-selected', el => el.disabled = false);
            Z.forFirst('button[data-quote-gui-tool="background"]', el => el.click());

            let isrc = cvs.toDataURL('jpeg', 30);
            Z.setValue('#SelectedBackgroundBase64', isrc, false);
            img = document.createElement('img');
            img.src = isrc;

        } else {
            Z.forEach('.hide-when-selected-background', el => el.classList.remove('d-none'));

            Z.forEach<HTMLButtonElement>('.disable-when-background-selected', el => el.disabled = false);
            Z.forEach<HTMLButtonElement>('.enable-when-background-selected', el => el.disabled = true);
            Z.forFirst('button[data-quote-gui-tool="select"]', el => el.click());

            Z.setValue('#SelectedBackgroundBase64', '', false);
        }
        this.activeBackground = img;

        this.backgroundX = 0;
        this.backgroundY = 0;
        this.backgroundScale = (this.canvas.width || 640) / (this.backgroundWidth || DataTransferImageWidth);

        this.resize(true);
        this.repaint();

        this.onDiff();

        Z.forFirst('.drag-drop-animation-over', el => {
            let anims = el.getAnimations();
            if (anims && anims.length) {
                let anim = anims[0];
                //console.log(anim);
                anim.play();
            }
        });

        setTimeout(() => {
            this.resize(true);
        }, 10);
    }

    backgroundDragOriginX: number = 0;
    backgroundDragOriginY: number = 0;

    measureStartX: number = 0;
    measureStartY: number = 0;
    measureToX: number = 0;
    measureToY: number = 0;
    isMeasuring: boolean = false;

    nominalMeasureScaleX: number = 1;
    nominalMeasureScaleY: number = 1;

    tweenMetreScaleTo: number = 0;
    tweenMetreScaleSteps: number = 0;
    tweenMetreScaleStep: number = 0;
    tweener;
    tween() {
        clearTimeout(this.tweener);
        if (this.tweenMetreScaleSteps > 0) {
            //console.log(`tween: ${this.tweenMetreScaleSteps}, ${this.metreScale}, ${this.tweenMetreScaleStep}`);
            //this.metreScale += this.tweenMetreScaleStep;
            this.tweenMetreScaleSteps--;

            this.repaint();

            this.tweener = setTimeout(() => this.tween(), 10);
        }
    }
    tweenScale(to: number) {
        this.tweenMetreScaleTo = to;
        this.tweenMetreScaleSteps = 50;
        //this.tweenMetreScaleStep = (to - this.metreScale) / this.tweenMetreScaleSteps;
        this.tween();
    }

    dragGridSelectionOriginX: number;
    dragGridSelectionOriginY: number;
    isDraggingGridSelection: boolean = false;
    isResizingGridSelectionX: boolean = false;
    isResizingGridSelectionY: boolean = false;
    resizingGridOriginalWidth: number = 0;
    resizingGridOriginalHeight: number = 0;
    get isResizingGridSelection() {
        return this.isResizingGridSelectionX || this.isResizingGridSelectionY;
    }
    set isResizingGridSelection(to: boolean) {
        this.isResizingGridSelectionX = to;
        this.isResizingGridSelectionY = to;
    }

    cursorStart(ev: ContainedDragEvent): void {
        if (Z.any('#webcam-capture:not(.d-none)')) {
            this.captureWebcam();
            this.imageSelectTool = 'crop';
            return;
        }

        Z.forFirst('.drag-drop-animation-over', el => {
            let anims = el.getAnimations();
            if (anims && anims.length) {
                let anim = anims[0];
                //console.log(anim);
                anim.finish();
            }
        });

        let withinSelection = false;
        let resizingX = false;
        let resizingY = false;
        if (this.fixedGridSelectX >= 0 && this.fixedGridSelectY >= 0) {

            let ex = ev.x / this.backgroundWidthOfCanvas;
            let ey = ev.y / this.backgroundHeightOfCanvas;

            let fx1 = this.fixedGridSelectX;
            let fy1 = this.fixedGridSelectY;
            let fx2 = fx1 + (this.selectionWidth * this.gridStep) / this.canvas.width;
            let fy2 = fy1 + (this.selectionHeight * this.gridStep) / this.canvas.height;

            let fx3 = fx1 + ((this.selectionWidth - 1) * this.gridStep) / this.canvas.width;
            let fy3 = fy1 + ((this.selectionHeight - 1) * this.gridStep) / this.canvas.height;

            if (ex >= fx1 && ex <= fx3 && ey >= fy1 && ey <= fy3) {
                withinSelection = true;

                this.dragGridSelectionOriginX = ex - fx1;
                this.dragGridSelectionOriginY = ey - fy1;

            } else if (ex >= fx1 && ex <= fx2 && ey >= fy1 && ey <= fy2) {
                withinSelection = true;

                this.dragGridSelectionOriginX = ex - fx1;
                this.dragGridSelectionOriginY = ey - fy1;
                this.resizingGridOriginalWidth = this.selectionWidth;
                this.resizingGridOriginalHeight = this.selectionHeight;

                resizingX = true;
                resizingY = true;
            }
        }

        if (withinSelection) {
            this.isResizingGridSelectionX = resizingX;
            this.isResizingGridSelectionY = resizingY;

            this.isDraggingGridSelection = !this.isResizingGridSelection;

        } else {
            this.isDraggingGridSelection = false;
            this.isResizingGridSelection = false;
            this.selectionWidth = 1;
            this.selectionHeight = 1;

            this.fixedGridSelectX = ev.x / this.backgroundWidthOfCanvas;
            this.fixedGridSelectY = ev.y / this.backgroundHeightOfCanvas;

            this.roundSelection();
        }
        this.repaint();
    }

    cursorMove(ev: ContainedDragEvent): void {

        if (this.isResizingGridSelection) {
            let diffX = Math.round(((ev.deltaX / this.backgroundWidthOfCanvas) * this.canvas.width) / this.gridStep);
            let diffY = Math.round(((ev.deltaY / this.backgroundHeightOfCanvas) * this.canvas.height) / this.gridStep);

            let newSizeX = this.resizingGridOriginalWidth + diffX;
            let newSizeY = this.resizingGridOriginalHeight + diffY;

            if (newSizeX < 3) newSizeX = 3;
            if (newSizeY < 3) newSizeY = 3;

            this.selectionWidth = newSizeX;
            this.selectionHeight = newSizeY;
            this.roundSelection();
        }

        else if (this.isDraggingGridSelection) {

            let movedX = ev.x / this.backgroundWidthOfCanvas - this.dragGridSelectionOriginX;
            let movedY = ev.y / this.backgroundHeightOfCanvas - this.dragGridSelectionOriginY;

            let width = (this.selectionWidth * this.gridStep) / this.canvas.width;
            let height = (this.selectionHeight * this.gridStep) / this.canvas.height;

            if (movedX <= 0) movedX = 0.000001;
            if (movedY <= 0) movedY = 0.000001;

            //console.log(`mv: ${movedX}, ${movedY} | size: ${width} x ${height}`);

            this.fixedGridSelectX = movedX;
            this.fixedGridSelectY = movedY;

        } else {
            this.selectionWidth = Math.abs((ev.deltaX) * ((this.canvas.width / this.backgroundWidthOfCanvas) / this.gridStep));
            this.selectionHeight = Math.abs((ev.deltaY) * ((this.canvas.height / this.backgroundWidthOfCanvas) / this.gridStep));

            this.roundSelection();
        }

        this.repaint();
        this.onChange();
    }

    get selectionWidthInMM() {
        return this.selectionWidth * 320;
    }
    get selectionHeightInMM() {
        return this.selectionHeight * 320;
    }

    cursorEnd(ev: ContainedDragEvent): void {
        this.isDraggingGridSelection = false;
        this.isResizingGridSelection = false;

        if (ev.isInsideElement) {
            if (ev.delta < 5) {
                if (this.activeTool == 'background') {
                    Z.forFirst(`button[data-quote-gui-tool="select"]`, btn => btn.click());
                }
            }

            //console.log(`cursor end, select size ${this.selectionWidth * 320}, ${this.selectionHeight * 320}`, ev);
            Z.setValue('input#RequestedSignWidthInMM', `${this.selectionWidthInMM}`, false);
            Z.setValue('input#RequestedSignHeightInMM', `${this.selectionHeightInMM}`, false);

            let preview = this.previewQuoteImage;
            if (preview && preview.length) {
                let fd = new FormData();
                fd.append('SelectedBackgroundBase64', preview);

                fetch(`/quote/updatepreview/${app.quoteBuilder.quoteId}`, {
                    method: 'post',
                    body: fd,
                });
            }

            //Z.setValue('input#PreviewImageBase64', this.previewQuoteImage, false);
            this.repaint();
        }

        this.isMeasuring = false;
    }

    

    roundSelection(direction: 'up' | 'down' = 'down') {
        let w = this.selectionWidth;
        let h = this.selectionHeight;

        const maxModulesWide = AcceptablePanelSizes.UpperAxisLimit;
        const maxModulesTall = AcceptablePanelSizes.UpperAxisLimit;
        const minModulesWide = 3;
        const minModulesTall = 3;

        const acceptablePanelSizesA = AcceptablePanelSizes.setB(AcceptablePanelSizes.UpperAxisLimit);
        const acceptablePanelSizesB = AcceptablePanelSizes.setA(AcceptablePanelSizes.UpperAxisLimit);
        const selectB = acceptablePanelSizesA.filter(i => acceptablePanelSizesB.indexOf(i) === -1);

        /*const acceptablePanelSizesA = [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24];
        const acceptablePanelSizesB = [3, 6, 9, 12, 15, 18, 21, 24];

        const selectB = [4, 7, 8, 11, 16, 19, 20, 23];

        const acceptablePanelSizes = {
            3: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            4: [3, 6, 9, 12, 15, 18, 21, 24],
            6: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            7: [3, 6, 9, 12, 15, 18, 21, 24],
            8: [3, 6, 9, 12, 15, 18, 21, 24],
            9: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            11: [3, 6, 9, 12, 15, 18, 21, 24],
            12: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            15: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            16: [3, 6, 9, 12, 15, 18, 21, 24],
            18: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            19: [3, 6, 9, 12, 15, 18, 21, 24],
            20: [3, 6, 9, 12, 15, 18, 21, 24],
            21: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
            23: [3, 6, 9, 12, 15, 18, 21, 24],
            24: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
        };*/

        let aalen = acceptablePanelSizesA.length;
        let ablen = acceptablePanelSizesB.length;

        if (acceptablePanelSizesA.indexOf(w) === -1) {
            for (let i = 0; i < aalen; i++) {
                if (w <= acceptablePanelSizesA[i]) {
                    w = acceptablePanelSizesA[i];
                    break;
                }
            }
        }
        if (acceptablePanelSizesA.indexOf(h) === -1) {
            for (let i = 0; i < aalen; i++) {
                if (h <= acceptablePanelSizesA[i]) {
                    h = acceptablePanelSizesA[i];
                    break;
                }
            }
        }

        if (selectB.indexOf(w) !== -1) {
            for (let i = 0; i < ablen; i++) {
                if (h <= acceptablePanelSizesB[i]) {
                    h = acceptablePanelSizesB[i];
                    break;
                }
            }
        }

        if (selectB.indexOf(h) !== -1) {
            for (let i = 0; i < ablen; i++) {
                if (w <= acceptablePanelSizesB[i]) {
                    w = acceptablePanelSizesB[i];
                    break;
                }
            }
        }

        if (w < minModulesWide) w = minModulesWide;
        if (h < minModulesTall) h = minModulesTall;
        if (w > maxModulesWide) w = maxModulesWide;
        if (h > maxModulesTall) h = maxModulesTall;

        this.selectionWidth = w;
        this.selectionHeight = h;
    }

    //hoverCellX: number = 0;
    //hoverCellY: number = 0;
    cursorHover(ev: ContainedDragEvent): void {
        //this.hoverCellX = Math.min(Math.floor(ev.x * this.canvas.width / this.gridStep), this.gridCellsWide - 1);
        //this.hoverCellY = Math.min(Math.floor(ev.y * this.canvas.height / this.gridStep), this.gridCellsTall - 1);

        let withinSelection = false;
        let resizingX = false;
        let resizingY = false;
        if (this.fixedGridSelectX >= 0 && this.fixedGridSelectY >= 0) {

            let ex = ev.x / this.backgroundWidthOfCanvas;
            let ey = ev.y / this.backgroundHeightOfCanvas;

            let fx1 = this.fixedGridSelectX;
            let fy1 = this.fixedGridSelectY;
            let fx2 = fx1 + (this.selectionWidth * this.gridStep) / this.canvas.width;
            let fy2 = fy1 + (this.selectionHeight * this.gridStep) / this.canvas.height;

            let fx3 = fx1 + ((this.selectionWidth - 1) * this.gridStep) / this.canvas.width;
            let fy3 = fy1 + ((this.selectionHeight - 1) * this.gridStep) / this.canvas.height;

            if (ex >= fx1 && ex <= fx3 && ey >= fy1 && ey <= fy3) {
                withinSelection = true;

            } else if (ex >= fx1 && ex <= fx2 && ey >= fy1 && ey <= fy2) {
                withinSelection = true;
                resizingX = true;
                resizingY = true;
            }
        }

        if (withinSelection) {
            if (resizingX || resizingY) {
                this.canvas.style.cursor = 'se-resize';
            } else {
                this.canvas.style.cursor = 'grab';
            }

        } else {
            this.canvas.style.cursor = 'cell';
        }

        this.repaint();
    }

    resize(force: boolean = false) {
        let bounds = this.canvas.parentElement.getBoundingClientRect();

        if (this.activeBackground) {
            let bgbounds = CanvasUtils.bestFit({ width: this.activeBackground.naturalWidth, height: this.activeBackground.naturalHeight }, bounds);
            bounds.width = bgbounds.width;
            bounds.height = bgbounds.height;
        } else {
            //console.log(`no active background (?)`);
        }

        if (this.canvas.width != Math.floor(bounds.width) || this.canvas.height != Math.floor(bounds.height) || force) {
            this.canvas.width = Math.floor(bounds.width);
            this.canvas.height = Math.floor(bounds.height);
            this.canvas.style.width = `${this.canvas.width}px`;
            this.canvas.style.height = `${this.canvas.height}px`;
        }
        this.repaint();
        this.onChange();
    }

    //gridScale: number = 1;
    /*get gridScale() {
        let scale = parseFloat(Z.valueOf('#GridScale', '1'));
        if (scale == 0) scale = 1;
        return scale;
    }
    set gridScale(to: number) {
        if (to == 0) to = 1;
        Z.setValue('#GridScale', to, false);
    }*/


    onChange() {
        Z.forEach(`#sign-designer-module-selection-label`, lbl => lbl.innerHTML = `${this.selectionWidth} x ${this.selectionHeight} modules<br/>${Math.round(this.selectionWidth * 32) / 100}m x ${Math.round(this.selectionHeight * 32) / 100}m`);

        let pitch = this.selectedPitch;
        let pitchMultipliers = this.pitchMultipliers;

        if (Object.keys(pitchMultipliers).indexOf(pitch) !== -1) {
            //console.log(pitchMultipliers[pitch]);
            Z.forEach(`.lbl-max-visibility-text`, lbl => lbl.innerText = `${Math.round(pitchMultipliers[pitch].max.text)}`);
            Z.forEach(`.lbl-max-visibility-image`, lbl => lbl.innerText = `${Math.round(pitchMultipliers[pitch].max.image)}`);
            Z.forEach(`.lbl-max-visibility-video`, lbl => lbl.innerText = `${Math.round(pitchMultipliers[pitch].max.video)}`);

            Z.forEach(`.lbl-min-visibility-text`, lbl => lbl.innerText = `${Math.round(pitchMultipliers[pitch].min.text)}`);
            Z.forEach(`.lbl-min-visibility-image`, lbl => lbl.innerText = `${Math.round(pitchMultipliers[pitch].min.image)}`);
            Z.forEach(`.lbl-min-visibility-video`, lbl => lbl.innerText = `${Math.round(pitchMultipliers[pitch].min.video)}`);
        }
    }

    get selectedPitch() {
        return Z.valueOf('#PixelPitch', '16').replace('mm', '').replace('.', '').replace('Please Select', '16');
    }

    get pitchMultipliers() {
        let mm = this.selectionHeightInMM;
        return {
            '5': {
                min: { text: 5, image: 10, video: 15 },
                max: { text: mm * 0.05, image: mm * 0.04, video: mm * 0.03 },
            },
            '667': {
                min: { text: 7, image: 12, video: 20 },
                max: { text: mm * 0.05, image: mm * 0.04, video: mm * 0.03 },
            },
            '8': {
                min: { text: 8, image: 15, video: 25 },
                max: { text: mm * 0.05, image: mm * 0.04, video: mm * 0.03 },
            },
            '10': {
                min: { text: 10, image: 20, video: 30 },
                max: { text: mm * 0.05, image: mm * 0.04, video: mm * 0.03 },
            },
            '1333': {
                min: { text: 13, image: 25, video: 40 },
                max: { text: mm * 0.05, image: mm * 0.04, video: mm * 0.03 },
            },
            '16': {
                min: { text: 15, image: 30, video: 50 },
                max: { text: mm * 0.05, image: mm * 0.04, video: mm * 0.03 },
            },
        };
    }

    canAccessUserMedia: boolean = false;
    checkUserMedia() {
        DDSB.log(`Checking user media...`);
        try {
            DDSB.log(navigator.mediaDevices.getSupportedConstraints());
            let constraints: MediaTrackConstraints = {
                facingMode: 'environment',
                //suppressLocalAudioPlayback: true,
            };
            navigator.mediaDevices.getUserMedia({
                audio: false,
                video: constraints,
            }).then(stream => {
                this.canAccessUserMedia = true;
                DDSB.log(stream);

                let video = Z.first<HTMLVideoElement>('video#webcam-capture');
                Z.forEach('.video-capture-icon.d-none', e => e.classList.remove('d-none'));
                video.classList.remove('d-none');
                video.onloadedmetadata = data => {
                    let width = video.videoWidth;
                    let height = video.videoHeight;
                    DDSB.log(`${width} x ${height}`);
                    video.play();
                };
                video.srcObject = stream;
                this.showImageSelectModal(null);


            }).catch(err => {
                DDSB.log(err);
                this.canAccessUserMedia = false;
            });

        } catch (err) {
            DDSB.log(err);
            this.canAccessUserMedia = false;
        }
    }

    captureWebcam() {
        if (!this.canAccessUserMedia) return;
        let video = Z.first<HTMLVideoElement>('video#webcam-capture');
        Z.forEach('.video-capture-icon', e => e.classList.add('d-none'));
        video.classList.add('d-none');
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        let aspect = video.videoWidth / video.videoHeight;
        canvas.width = DataTransferImageWidth;
        canvas.height = DataTransferImageWidth / aspect;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        let imgsrc = canvas.toDataURL('image/jpeg', 30);
        console.log(imgsrc);
        let img = document.createElement('img');
        img.src = imgsrc;
        img.onload = ev => {
            //this.selectBackground(img);
            //this.showImageSelectModal(img);
            Z.setData(this.photoSelectionModal, 'image', img);
            this.redrawImageSelectModal();
            this.imageSelectTool = 'crop';

            Z.forEach('#photo-selection-modal .step', step => step.classList.add('d-none'));
            Z.forEach('#photo-selection-modal .step-1', step => step.classList.remove('d-none'));
            Z.forEach('#photo-selection-modal .photo-select-tools', div => div.classList.remove('d-none'));
        }

        video.src = null;
    }

}